import React, { useEffect, useState } from 'react';
//import './assets/css/body.css'; // Import CSS from the theme
import { useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { getCleanedDomainName } from './urlFetch';
import {Helmet} from "react-helmet";
import { SubscribeRibbon } from './SubscribeRibbon';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

function PageNotFound() {
  
  return (
    <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Page Not Found!</title>
    </Helmet>


    {/* Articles Section */}
    <section class="layout-pt-lg layout-pb-md relative" id="secondSection">
      <div data-anim-wrap="" class="container animated">
        <div data-anim-child="slide-up delay-1" class="row y-gap-20 justify-center text-center is-in-view">
          <div class="col-auto">
            <div class="sectionTitle -md"><br></br><br></br><br></br><br></br>
              <h2 class="sectionTitle__title">Oops, This Page Was Not Found!</h2><br />
                                <h4><a href="/">Return to Homepage</a></h4><br></br><br></br><br></br>
              {/*<p class=" sectionTitle__text mt-5 sm:mt-0">Here are list of nearby places that you might be intersted in</p>*/}
            </div>
          </div>
        </div>
      </div>
    </section>

    <SubscribeRibbon />

    </>
  );
}

export default PageNotFound;